<template>
  <div>
    <v-data-table

      ref="bookingSummaryList"
      disable-pagination
      style="width: 100%; font-size: 12px !important;"
      :headers="headers"
      hide-default-header
      :items="bookings"
      :options.sync="pagination"
      :hide-default-footer="true"
      dense
    >
      <template v-slot:header="{ props }">
        <th v-for="head in props.headers">
          <div v-if="head.text == 'ID'">
            <v-text-field
              v-model="query.refNum"
              style="font-size: 11px !important;"
              hide-details
              label="Reference"
              @keyup.enter="search"
            />
          </div>
          <div v-else-if="head.text == 'Name'">
            <v-text-field
              v-model="query.name"
              style="font-size: 11px !important;"
              hide-details
              label="Customer"
              @keyup.enter="search"
            />
          </div>
          <div v-else-if="head.text == 'State'">
            <v-select
              v-model="query.state"
              :items="states"
              item-value="value"
              item-text="name"
              label="State"
              hide-details
              style="font-size: 11px !important;"
            />
          </div>
          <div v-else-if="head.text == 'LT'">
            <v-select
              v-model="selectedLocationTypes"
              :items="locationTypes"
              item-value="value"
              item-text="name"
              label="LT"
              hide-details
              multiple
              hint="Location types"
              persistent-hint
              style="font-size: 11px !important;"
              @keydown.delete="resetSelectedLocationTypes"
              @change="$emit('locationTypesUpdated', selectedLocationTypes)"
            >
              <template v-slot:item="{ item, index}">
                <small>{{ item.name }}</small>
              </template>
              <template v-slot:selection="{ item, index }">
                <span
                  v-if="index === 0"
                  class="grey--text text-caption"
                >
                  (+{{ selectedLocationTypes.length }})
                </span>
              </template>
            </v-select>
          </div>
          <div v-else-if="head.text == 'Additional'">
            <v-select
              v-model="selectedBookingTypes"
              :items="bookingTypes"
              item-value="value"
              item-text="name"
              label="Booking Type"
              hide-details
              multiple
              hint="Pick types"
              persistent-hint
              style="font-size: 11px !important;"
              @keydown.delete="resetSelectedBookingTypes"
              @change="$emit('bookingTypesUpdated', selectedBookingTypes)"
            >
              <template v-slot:item="{ item, index}">
                <small>{{ item.name }}</small>
              </template>
              <template v-slot:selection="{ item, index }">
                <span
                  v-if="index === 0"
                  class="grey--text text-caption"
                >
                  (+{{ selectedBookingTypes.length }})
                </span>
              </template>
            </v-select>
          </div>
          <div v-else-if="head.text == 'Pickup'">
            <v-text-field
              v-model="query.pickup"
              style="font-size: 11px !important;"
              hide-details
              label="Pickup"
              @keyup.enter="search"
            />
          </div>
          <div v-else-if="head.text == 'Destination'">
            <v-text-field
              v-model="query.destination"
              style="font-size: 11px !important;"
              hide-details
              label="Destination"
              @keyup.enter="search"
            />
          </div>
          <div v-else-if="head.text == 'Date'">
            <v-row class="flex-nowrap" justify="center" align="center">
              <BookingDateInput
                :content="query.after"
                label="From"
                :old="true"
                :range="true"
                @input="fromChanged"
              />
              <v-icon
                v-if="query.after != '' || query.before != ''"
                :size="12"
                style="padding-top: 0px;"
                @click="clearDateRange"
              >
                clear
              </v-icon>

              <v-checkbox
                class="pb-1"
                v-model="query.todayBookings"
                dense
                title="Today Bookings"
                inset
                label="Today"
                hide-details
                @change="$emit('updateTodayBookings')"
              />
              <v-menu>
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        x-small
                        elevation="0"
                        class="ml-1"
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                      >
                        Bid
                      </v-btn>
                    </template>
                    <span>Bid Filters</span>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-list-item>
                    <v-btn-toggle
                      v-model="query.bid"
                      rounded="0"
                      color="green"
                      group
                    >
                      <v-btn small value="on_bid">
                        BID
                      </v-btn>

                      <v-btn small value="non_bid">
                        NON BID
                      </v-btn>

                      <v-btn small value="all">
                        ALL
                      </v-btn>
                    </v-btn-toggle>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!--
                            <BookingDateInput
                              @input="toChanged"
                              :content="query.before"
                              label="To"
                              :old="true"
                            />
              -->
              <!--
                            <v-icon v-if="query.before != ''" :size="12" @click="query.before = ''" style="padding-top: 0px;">clear</v-icon>
              -->
            </v-row>
          </div>
          <div v-else-if="head.text == 'ptype'">
            <v-select
              v-model="query.paymentType"
              style="font-size: 11px !important;"
              :items="paymentTypes"
              hide-details
              item-value="value"
              item-text="name"
              dense
              label="PType"
            />
          </div>
          <div v-else-if="head.text == 'Driver'">
            <v-text-field
              v-model="query.preassignedDriver"
              style="font-size: 11px !important;"
              hide-details
              label="Driver"
              @keyup.enter="search"
            />
          </div>
          <div v-else-if="head.text == 'Search'">
            
            <v-btn
              color="blue"
              x-small
              class="text-none"
              text
              @click="search"
            >
              Search
            </v-btn>
          </div>
          <div v-else>
            {{ head.text }}
          </div>
        </th>
      </template>
      <template v-slot:item="props">
        <tr
          :class="{'pink-background': props.item.driver_compliant == false}"
          style="height: 44px !important; font-size: 12px !important;"
          @dblclick="goToBooking(props.item.id)"
        >
          <td style="width:5%; font-size: 12px !important;">
            <div>
              <span>
                {{ props.item.id }}
                <br>
                <p v-if="!isSystemGenerated(props.item.ref_num)">{{ props.item.ref_num }}
                  <br>
                </p>
                <p :style="{color: locationTypeColor(destinationLocationTypeForBooking(props.item))}">
                  {{ destinationLocationTypeForBooking(props.item) }}
                </p>
              </span>
            </div>
          </td>
          <td>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td style="width:7%;">
            <div>
              <span>
                <!--
                <a
                  href="#"
                  @click.stop="goToUser(props.item.user_id)"
                >{{ props.item.user_name }}</a>
-->
                <v-menu offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <a
                      href="javascript:void(0)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ props.item.user_name }}
                    </a>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-if="props.item.contact_number"
                    >
                      <v-list-item-title>
                        <a :href="'tel:' + props.item.contact_number">Call Rider</a>
                      </v-list-item-title>
                      <v-spacer />
                      <v-icon
                        color="blue"
                        class="ml-2"
                        @click="copyContent(props.item.contact_number)"
                      >mdi-content-copy</v-icon>
                    </v-list-item>
                    <v-list-item
                      v-if="props.item.email"
                    >
                      <v-list-item-title>
                        <a
                          :href="'mailto:' + props.item.email"
                        >Email Rider</a>
                      </v-list-item-title>
                      <v-spacer />
                      <v-icon
                        color="blue"
                        class="ml-2"
                        @click="copyContent(props.item.email)"
                      >mdi-content-copy</v-icon>
                    </v-list-item>

                    <v-list-item
                      v-if="props.item.business_customer_number"
                    >
                      <v-list-item-title>
                        <a
                          :href="'tel:' + props.item.business_customer_number"
                        >Call Account</a>

                      </v-list-item-title>
                      <v-spacer />
                      <v-icon
                        color="blue"
                        class="ml-2"
                        @click="copyContent(props.item.business_customer_number)"
                      >mdi-content-copy</v-icon>
                    </v-list-item>
                    <v-list-item
                      v-if="props.item.business_customer_email"
                    >
                      <v-list-item-title>
                        <a
                          :href="'mailto:' + props.item.business_customer_email"
                        >Email Account</a>
                      </v-list-item-title>
                      <v-spacer />
                      <v-icon
                        color="blue"
                        class="ml-2"
                        @click="copyContent(props.item.business_customer_email)"
                      >mdi-content-copy</v-icon>
                    </v-list-item>

                    <v-list-item
                    >
                      <v-list-item-title>
                        <a
                          href="#"
                          @click.stop="goToUser(props.item.user_id)"
                        >View Account</a>
                      </v-list-item-title>
                      <v-spacer />
                      <v-icon
                        color="blue"
                        class="ml-2"
                      >mdi-arrow-right</v-icon>
                    </v-list-item>

                  </v-list>
                </v-menu>
                <br>
                <p v-if="props.item.business_customer_name">{{ props.item.business_customer_name }}</p>
              </span>
            </div>
          </td>
          <td
            style="width:1%;"
            v-html="numPeople(props.item)"
          />
          <td style="width:3%;">
            {{ props.item.pickup_time.split(" ")[0  ] }}
          </td>
          <td style="width:3%;">
            {{ props.item.pickup_time.split(" ")[1] }}
          </td>
          <td style="width:3%;">
            {{ findRideTypeFromList(props.item.ride_type_id) }}
          </td>
          <td style="width:30%;">
            <div class="">
              {{ props.item.pickup_location | removeUK | removePostCode }} <b> <span>&nbsp; {{ props.item.pickup_location | extractPostCode }} </span></b>
            </div>
          </td>
          <td style="width:3%; cursor: pointer">
            <ViasForBooking :booking="props.item" />
          </td>
          <td style="width:30%;">
            <div class="ffixed-booking-table-row">
              {{ destinationForBooking(props.item) | removeUK | removePostCode }} <b>&nbsp;<span> {{ destinationForBooking(props.item) | extractPostCode }} </span></b>
            </div>
          </td>
          <td
            v-if="props.item.state == 'booked'"
            style="width:10%;"
          >
            <v-edit-dialog
              @save="save"
              @cancel="cancel"
              @open="open"
              @close="close"
            >
              <div
                style="/*background-color: #F9F0FF; */ border-radius: 6px; padding-left: 4px; padding-right: 4px;
              "
              >
                <p>
                  <b>{{ props.item.preassigned_driver_callsign }}
                    {{ props.item.preassigned_driver_name }}</b>
                </p>
                <div v-if="props.item.taxi">
                  <span style="display: inline">{{ props.item.taxi.registration_number }}</span>
                  <span
                    style="display: inline"
                    class="ml-1"
                  >{{ props.item.taxi.color }}</span>
                  <br>
                  <span style="display: inline">{{ props.item.taxi.make }}</span>
                  <span
                    style="display: inline"
                    class="ml-1"
                  >{{ props.item.taxi.type }}</span>
                </div>
              </div>
              <template v-slot:input>
                <div>
                  <SelectableDriverDropdownInput
                    v-model="props.item.preassigned_driver_id"
                    hide-details
                    label="Preassign Driver"
                    :booking-summary="props.item"
                  />
                </div>
              </template>
            </v-edit-dialog>
          </td>
          <td
            v-if="props.item.state != 'booked'"
            style="width:10%"
          >
            <p v-if="props.item.driver_id">
              <b>{{ props.item.driver_callsign }}</b>
              {{ props.item.driver }}
            </p>
          </td>
          <td style="width: 2%; text-transform: capitalize;">
            {{
              props.item.fixed_cost ? (props.item.final_cost / 100).toFixed(2) : (props.item.estimated_cost / 100).toFixed(2)
            }}
          </td>
          <td style="width: 2%; text-transform: capitalize;">
            {{driverFinalAfterCommission(props.item)}}
<!--
            {{ props.item.fixed_cost_driver != 0 ? (props.item.fixed_cost_driver / 100).toFixed(2) : "-" }}
-->
          </td>
          <td style="width: 4%; text-transform: capitalize;">
            {{ paymentMethodFormat(props.item.payment_type) }}
          </td>
          <td style="width: 2%; text-transform: capitalize;">
            {{ secondsToDuration(props.item.route_time) }}
          </td>
          <td style="width: 2%; text-transform: capitalize;">
            {{ Math.ceil((props.item.route_distance * 0.000621371192).toFixed(1)) }}
          </td>
          <td style="width: 2%; text-transform: capitalize;">
            {{ finishTime(props.item) }}
          </td>
          <td style="width: 2%; text-transform: capitalize; !important;">
            <span :style="{color: getStateColor(props.item.state)}">
              {{ props.item.state }}
            </span>
          </td>
          <td style="width: 5%; text-transform: capitalize;">
            <AttributesForBookingCell :booking="props.item" :booking-attributes-to-show="bookingAttributesToShow" />
          </td>
          <td>
            <v-row class="flex-nowrap">
              <v-flex>
                <BookingActions
                  :booking-form="bookingForm"
                  :repeat-trip-id="bookingRepeatServiceId"
                  :update-mode="true"
                  :simplified="true"
                  @reload="reload"
                  @cancelledBooking="reload"
                  @morePressed="showBookingMenu(props.item.id, props.item.booking_type)"
                  @bookingConfirmed="reload"
                />
              </v-flex>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="viewBookingDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5f9;">
        <v-toolbar
          dark
          color="secondary"
        >
          <v-btn
            icon
            dark
            @click="closeViewBookingDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            View/Edit Booking
            #{{ currentBookingID + " - " + (bookingForm != null ? bookingForm.booking.state : "") }}
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-flex v-if="loadingEditBooking == true">
          <v-progress-linear
            indeterminate
            color="yellow darken-2"
          />
        </v-flex>
        <LargeBookForm
          v-if="viewBookingDialog == true"
          :update-mode="true"
          :booking-form="bookingForm"
          @cancelledBooking="cancelledBooking"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LargeBookForm from "@/components/booking/LargeBookForm.vue";
import {BookingForm} from "@/components/util/BookingForm.js";

import BookingDateInput from "@/components/widget/input/BookingDateRangeInputSmall.vue";

import SelectableDriverDropdownInput from "@/components/widget/input/SelectableDriverDropdownInput.vue";
import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";

import BookingActions from "@/components/widget/input/BookingActions.vue";

import qs from "qs";
import axios from "axios";
import {setTimeout} from "timers";

axios.defaults.withCredentials = true;

import moment from "moment";

import {Overwatch} from "@/components/util/Overwatch.js";

export default {
  name: "BookingSummaryList",
  components: {
    LargeBookForm,
    SelectableDriverDropdownInput,
    ViasForBooking,
    BookingDateInput,
    AttributesForBookingCell,
    BookingActions
  },
  filters: {
    hideSystemGeneratedBusinessRefNo (businessRefNo) {
      return businessRefNo.includes("SYS") ? "" : businessRefNo
    },
    removeUK (address) {
      if (address) {
        return address.replace(", UK", "").replace("UK", "")
      }
      return address
    },
    removePostCode (address) {
      const postCodeRegex = /[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}/
      if (address) {
        if (postCodeRegex.test(address))  {
          return address.replace(postCodeRegex, "")
        }
      }
      return address
    },
    extractPostCode (address) {
      const postCodeRegex = /[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}/
      if (address) {
        if (postCodeRegex.test(address))  {
          return address.match(postCodeRegex)[0]
        }
      }
      return ''
    }
  },
  props: {
    bookings: Array,
    paginationProp: Object,
    rideTypes: Array,
    query: Object
  },
  data: function () {
    return {
      bookingAttributesToShow: [
        'offer_booking_publically'
      ],
      defaultCommissionPercentage: 20,
      selectedBookingTypes: [],
      selectedLocationTypes: [],
      dialog: Object,
      pagination: this.paginationProp,
      currentBookingID: -1,
      viewBookingDialog: false,
      loadingEditBooking: false,
      bookingForm: null,
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "LT",
          align: "left",
          sortable: false,
          value: "offer_booking_publically"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "PAX",
          align: "left",
          sortable: false,
          value: "pax"
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "pickup_date"
        }, {
          text: "Time",
          align: "left",
          sortable: false,
          value: "pickup_time"
        },
        {
          text: "Ride",
          align: "left",
          sortable: false,
          value: "ride_type_id"
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "pickup"
        },
        {
          text: "Via(s)",
          align: "left",
          sortable: false,
          value: "vias"
        },
        {
          text: "Destination",
          align: "left",
          sortable: false,
          value: "destinations"
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "driver"
        },
        {
          text: "£",
          align: "left",
          sortable: false,
          value: "£"
        },
        {
          text: "£dri",
          align: "left",
          sortable: false,
          value: "£"
        },
        {
          text: "ptype",
          align: "left",
          sortable: false,
          value: "payment_type"
        },
        {
          text: "Dur",
          align: "left",
          sortable: false,
          value: "duration"
        },
        {
          text: "Miles",
          align: "left",
          sortable: false,
          value: "miles"
        },
        {
          text: "Finish",
          align: "left",
          sortable: false,
          value: "finish"
        },
        {
          text: "State",
          align: "left",
          sortable: false,
          value: "state"
        },
        {
          text: "Additional",
          align: "left",
          sortable: false,
          value: "additional"
        },
        {
          text: "Search",
          align: "left",
          sortable: false,
          value: "actions"
        },

      ],
      states: [
        {
          id: 0,
          value: "all",
          name: "All"
        },
        {
          id: 1,
          value: "booked",
          name: "Booked"
        },
        {
          id: 2,
          value: "accepted",
          name: "Active"
        },
        {
          id: 3,
          value: "completed",
          name: "Completed"
        },
        {
          id: 4,
          value: "cancelled",
          name: "Cancelled"
        },
        {
          id: 5,
          value: "unconfirmed",
          name: "Unconfirmed"
        },
        {
          id: 5,
          value: "no_driver_available",
          name: "No Driver Available"
        },
      ],
      bookingTypesArray: [
        'All', 'Phone', 'App'
      ],
      bookingTypes: [
        {
          id: 0,
          value: "all",
          name: "All"
        },
        {
          id: 1,
          value: "phone",
          name: "Phone"
        },
        {
          id: 2,
          value: "app",
          name: "App"
        },
        {
          id: 3,
          value: "website",
          name: "Website"
        },
        {
          id: 4,
          value: "third_party",
          name: "Third Party"
        },
        {
          id: 4,
          value: "flag_down",
          name: "Flag Down"
        },
        {
          id: 4,
          value: "repeat",
          name: "Repeat"
        },
      ],
      locationTypes: [
        {
          id: 0,
          value: "all",
          name: "All"
        },
        {
          id: 1,
          value: "cruise",
          name: "Cruise"
        },
        {
          id: 2,
          value: "airport",
          name: "Airport"
        },
        {
          id: 3,
          value: "bus_station",
          name: "Bus Station"
        },
        {
          id: 4,
          value: "doctor",
          name: "Doctor"
        },
        {
          id: 5,
          value: "hospital",
          name: "Hospital"
        },
        {
          id: 6,
          value: "light_rail_station",
          name: "Light Rail Station"
        },
        {
          id: 7,
          value: "local_government_office",
          name: "Local Government Office"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
        {
          id: 8,
          value: "school",
          name: "School"
        },
        {
          id: 8,
          value: "secondary_school",
          name: "Secondary School"
        },
        {
          id: 8,
          value: "subway_station",
          name: "Subway Station"
        },
        {
          id: 8,
          value: "tourist_attraction",
          name: "Tourist Attraction"
        },
        {
          id: 8,
          value: "train_station",
          name: "Train Station"
        },
        {
          id: 8,
          value: "transit_station",
          name: "Transit Station"
        },
        {
          id: 8,
          value: "university",
          name: "University"
        },
        {
          id: 8,
          value: "Zoo",
          name: "Zoo"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
      ],
      paymentTypes: [
        {
          id: 0,
          value: "all",
          name: "All"
        },
        {
          id: 1,
          value: "cash",
          name: "Cash"
        },
        {
          id: 2,
          value: "card",
          name: "Card"
        },
        {
          id: 3,
          value: "card_in_cab",
          name: "CiC"
        },
        {
          id: 4,
          value: "account",
          name: "Acc"
        }
      ],
    };
  },
  computed: {
    bookingRepeatServiceId () {
      let response = this.$store.getters['booking/getBookingRepeatServiceId']
      if (response && response.repeat_service_id) {
        return response.repeat_service_id
      }
      return null
    },
    rideTypesList () {
      return this.$store.getters['rideType/getRideTypes']
    }
  },
  watch: {
    selectedBookingTypes () {

    }
  },

  mounted: async function () {
    this.$store.dispatch('rideType/getRideTypes')
    if (this.$route.query.bookingID) {
      this.goToBooking(this.$route.query.bookingID);
      this.$route.query.bookingID = null;
    }
    this.fillUpSelectedBookingTypesAndLocationTypes()
  },
  methods: {
    driverFinalAfterCommission: function (booking) {
      if ( booking.fixed_cost_driver || booking.final_cost || booking.estimated_cost) {
        var finalFare = booking.fixed_cost_driver;
        if(!finalFare) {
          finalFare = booking.final_cost
        }
        if(!finalFare) {
          finalFare = booking.estimated_cost
        }
        if (finalFare) {
          if (booking.fixed_commission != null && booking.fixed_commission > 0) {
            finalFare -= booking.fixed_commission
          } else if (booking.fixed_commission == 0) {
            finalFare -= booking.fixed_commission
          } else if (booking.driver_fee_percentage ) {
            finalFare -= (booking.driver_fee_percentage/100.0) * finalFare
          } else {
            finalFare -= (this.defaultCommissionPercentage/100) * finalFare
          }
        }
        if (finalFare != 0 && finalFare != null) {
          return ((finalFare/100)).toFixed(2);
        }
      }
      return booking.estimated_cost
    },
    isSystemGenerated (refNum) {
      return refNum && refNum.includes("SYS")
    },
    clearDateRange () {
      this.query.after = '';
      this.query.before = ''
    },
    resetSelectedBookingTypes () {
      this.selectedBookingTypes = []
      this.$emit('bookingTypesUpdated', [])
    },
    resetSelectedLocationTypes () {
      this.selectedLocationTypes = []
      this.$emit('locationTypesUpdated', [])
    },
    fillUpSelectedBookingTypesAndLocationTypes () {
      this.selectedBookingTypes = this.query.bookingMethod && !this.query.bookingMethod.includes("all") ? this.query.bookingMethod.split(",") : []
      this.selectedLocationTypes = this.query.locationTypes ? this.query.locationTypes.split(",") : []
    },
    copyContent (content) {
      if (content) {
        navigator.clipboard.writeText(content);
      }
    },
    getStateColor (state) {
      if (state && state.toLowerCase() === 'completed') {
        return 'green'
      }
      return ''
    },
    findRideTypeFromList (rideTypeId) {
      let rideType = this.rideTypesList.find(rideType => {
        return rideType.id == rideTypeId
      })
      if (rideType) {
        return rideType.name
      }
      return null
    },
    paymentMethodFormat(paymentMethod) {
      if (paymentMethod.toLowerCase() == 'card_in_cab') {
        return 'In Cab'
      }
      return paymentMethod
    },
    numPeople: function (booking) {
      if (booking.num_people > 4) {
        return '<div class="circle">' + booking.num_people + "</div>"
      } else {
        return '<div class="center">' + booking.num_people + "</div>";
      }
    },
    fromChanged: function (d) {
      this.query.after = d[0];
      this.query.before = d[1];
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search() {
      this.$emit("search")
    },
    secondsToDuration(d) {
      return Overwatch.secondsToHoursMinutesString(d);
    },
    finishTime(b) {

      // if (b.state == 'completed') {
      //   return moment(b.finished_time, "DD/MM/YYYY HH:mm").format("HH:mm");
      // }

      var put = moment(b.pickup_time, "DD/MM/YYYY HH:mm");
      var routeDurationMinutes = b.route_time / 60;

      return put.add(routeDurationMinutes, "minutes").format("HH:mm");
    },
    cancelledBooking() {

      var vm = this;
      this.bookings.forEach(function (b) {
        if (b.id == vm.currentBookingID) {
          b.state = "cancelled";
        }
      });
      this.cancelEditBooking();
    },
    save() {
      console.log("save");
    },
    cancel() {
      console.log("cancel");
    },
    close() {
      console.log("close");
    },
    open() {
      console.log("open");
    },
    async getBookingForEdit(bookingID) {
      this.loadingEditBooking = true;

      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {}
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        return "Unknown Error";
      }
    },
    goToBooking(id) {
      this.currentBookingID = id;
      return window.open('/bookings/' + id, '_blank')
    },
    goToBookingWithDialog: function (id) {
      this.cancelEditBooking(false);

      this.currentBookingID = id;

      var vm = this;

      vm.$nextTick(async function () {
        this.viewBookingDialog = true;

        var booking = await vm.getBookingForEdit(id);


        if (typeof booking === "string") {
          this.editBookingError = booking;
          alert(this.editBookingError);
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
              this.rideTypes,
              bookingUser,
              this.$store
          );
        }

        this.loadingEditBooking = false;
      });
    },
    showBookingMenu: function (id, type = null) {
      this.$store.commit('booking/setBookingRepeatServiceId', null)
      if (type && type == 'repeat') {
        this.$store.dispatch('booking/getBookingRepeatServiceId', id)
      }
      this.bookingForm = null;

      this.cancelEditBooking(false);

      this.currentBookingID = id;

      var vm = this;

      vm.$nextTick(async function () {
        var booking = await vm.getBookingForEdit(id);
        
        if (typeof booking === "string") {
          this.editBookingError = booking;
          alert(this.editBookingError);
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
              this.rideTypes,
              bookingUser,
              this.$store
          );
        }

        this.loadingEditBooking = false;
      });
    },
    reload: function () {
      this.$emit("reload", null);
    },
    cancelEditBooking: function (reload) {
      this.bookingForm = null;

      this.loadingEditBooking = true;
      this.editBookingError = null;
      this.viewBookingDialog = false;

      if (reload != false) {
        this.$emit("reload", null);
      }
    },
    closeViewBookingDialog: function () {
      this.cancelEditBooking();
    },
    goToUser: function (id) {
      window.open(`/customer/view/${id}`, "_blank");
    },
    goToDriver: function (id) {
      window.open(`/driver/view/${id}`, "_blank");
    },
    destinationForBooking: function (booking) {
      var destinations = "-";

      if (booking.destinations.length > 0) {
        return booking.destinations[0].description;
      }

      return destinations;
    },
    destinationLocationTypeForBooking: function (booking) {
      var destinations = "";

      if (booking.destinations.length > 0) {
        let locationType = booking.destinations[0].type;
        if (locationType) {
          return locationType
        }
        return ''
      }

      return destinations;
    },
    locationTypeColor: function (locationType) {
      switch (locationType) {
        case 'airport':
          return '#E88181FF'
        case 'cruise':
          return 'blue'
        default:
          return ''
      }
    },
    ratingForItem: function (booking) {
      if (booking.rating) {
        return booking.rating + "⭐";
      } else {
        return "";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 4px !important;
}

thead th:not(:first-child) {
  padding: 0 8px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 22px;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.v-data-table td {
  font-size: 12px !important;
  height: 19px;
}

.v-data-table th {
  font-size: 12px !important;
  height: 19px;
}

.circle {
  width: 16px;
  height: 16px;
  line-height: 15px;
  border-radius: 50%;
  background: #FFBB96;
  text-align: center;
}

td {
  line-height: 1.1;
}

.v-data-table td, .v-data-table th {
  padding: 0 2px !important;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.pink-background {
  background-color: pink !important;
}
</style>
